import { jsx as u } from "react/jsx-runtime";
import a from "react-select";
import { buildCustomDropdownComponents as c } from "./CustomComponents.js";
import d from "./hooks/useGetDropdownStyles.js";
function C(o) {
  const {
    dataNoTranslate: t,
    styles: f,
    size: e = "small",
    error: r = !1,
    menuWidth: s,
    noInputBox: n,
    children: m,
    ...p
  } = o, l = d({
    size: e,
    error: r,
    menuWidth: s,
    noInputBox: n
  }), i = c({ dataNoTranslate: t, children: m });
  return /* @__PURE__ */ u(a, { components: i, styles: l, ...p });
}
export {
  C as default
};
